const mapLocations = {
  SCHOOL: 'School',
  CAFE: 'Cafe',
  PARK: 'Park',
  MARKET: 'Market',
  HOME: 'Home',
  HOUSE: 'House',
};

const buttonLabels = {
  SCHOOL: 'schoolButton',
  CAFE: 'cafeButton',
  PARK: 'parkButton',
  MARKET: 'marketButton',
  HOME: 'homeButton',
  HOUSE: 'houseButton',
};

export const locations = Object.keys(mapLocations).map(
  location => ({
    locationName: location,
    id: buttonLabels[location],
  }),
);

export default mapLocations;
